import type { CSSProperties } from 'styled-components';

import { InputTitle } from 'components/input/InputTitle';
import { Button, Row, TextInput } from 'enable-ui';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

import { COLOR } from 'constants/color';

interface Props {
  password: string;
  handleChange: any;
  disabledField?: boolean;
  styles?: CSSProperties;
  isAccount?: {
    value: boolean;
    setValue: (value: boolean) => void;
  };
}

export const LearnerPasswordForm: React.FC<Props> = ({
  handleChange,
  password,
  disabledField,
  styles,
  isAccount,
}) => {
  return (
    <Row
      direction="column"
      style={{
        marginTop: 16,
        borderTop: `1px solid ${COLOR.neutralTrans['neutralTrans-25']}`,
        ...styles,
      }}
    >
      <InputTitle
        title={'Mobile app account'}
        style={{
          paddingTop: 12,
          color: COLOR.surfaceNeutralBold['neutral-11'],
          fontSize: 22,
          lineHeight: '30px',
          fontWeight: 500,
          marginBottom: 18,
        }}
      />
      {isAccount?.value ? (
        <div style={{ width: '100%' }}>
          <InputTitle title={'Password'} />
          <Row
            style={{
              gap: 4,
            }}
          >
            <TextInput
              name="password"
              type="password"
              placeholder="Enter password for mobile app account"
              containerStyle={{ maxWidth: 'auto' }}
              value={password}
              onChange={handleChange}
              disabled={disabledField}
            />
            <Button
              color="default"
              placementIcon="left"
              variant="outlined"
              onClick={() => {
                isAccount.setValue(false);
                handleChange({ target: { name: 'password', value: '' } });
              }}
              icon={<CloseIcon />}
              style={{
                height: 44,
                width: 44,
                borderColor: 'transparent',
              }}
            />
          </Row>
        </div>
      ) : (
        <Button
          color="default"
          variant="outlined"
          onClick={() => isAccount?.setValue(true)}
          style={{
            backgroundColor: '#FFFDF7',
            border: '1px solid #383ECD',
            color: '#383ECD',
          }}
        >
          Create mobile app account
        </Button>
      )}
    </Row>
  );
};
